import { ManagementBalanceApi } from "@/api";
import i18n from "@/i18n";
import router from "@/router";
import { showSuccessSnackbar } from "@/utilities/snackbar";
import { JsonUtils } from "@/utilities/jsonUtils";

export async function getSchema(params) {
  const { data } = await ManagementBalanceApi.getSchema(params);
  return data;
}

export async function getConstraints() {
  const { data } = await ManagementBalanceApi.getConstraints();
  return data;
}
/* export async function download(params) {
  let data;
  try {
    ({ data: data } = await ManagementBalanceApi.download(params));
  } catch (ex) {
    if (ex.response.status === 404) {
      // TODO: check if it's the correct move
      router.push({ name: "balances.index" });
    }
  }
  return data;
} */

export async function get(id) {
  const { data } = await ManagementBalanceApi.get(id);
  data.splits = JSON.parse(data.splits);
  data.data = JSON.parse(data.data, JsonUtils.infinityReviver);
  return data;
}

export async function getByEnterpriseId(id) {
  let data;
  try {
    ({ data: data } = await ManagementBalanceApi.getByEnterpriseId(id));
  } catch (ex) {
    if (ex.response.status === 404) {
      router.push({ name: "users" });
    }
  }
  return data;
}

export async function getBlobByHash(hash) {
  let { data } = await ManagementBalanceApi.getBlobByHash(hash);
  data = JSON.parse(data, JsonUtils.infinityReviver);
  return data;
}

export async function save(balance) {
  const { data } = await ManagementBalanceApi.save(balance);
  showSuccessSnackbar(200, i18n.t("balance-saved-correctly"));
  return data;
}

export async function remove(id) {
  await ManagementBalanceApi.remove(id);
  showSuccessSnackbar(200, i18n.t("balance-deleted-correctly"));
}
